import { render, staticRenderFns } from "./stafforder.vue?vue&type=template&id=06d66bb9&scoped=true"
import script from "./stafforder.vue?vue&type=script&lang=js"
export * from "./stafforder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d66bb9",
  null
  
)

export default component.exports